import { AddToCartButton } from '../components/AddToCartButton';
import { connect } from 'react-redux';

import {
  changeVariantQuantity,
  saveCartRequest,
  openCartForDesktop,
} from '../actions';
import {
  getPendingQuantitiesByLineItem,
  getPendingQuantity,
  getSubscriptionConflict,
  getLineItemQuantitySaved,
} from '../selectors';

const mapStateToProps = (state, props) => ({
  pendingQuantity: getPendingQuantity(state),
  pendingQuantities: getPendingQuantitiesByLineItem(state),
  hasSubscriptionConflict: getSubscriptionConflict(state),
  lineItemsPending: state.lineItemsPending,
  isSaving: state.isSaving,
  isOpen: state.isOpen,
  variantsSaving: state.variantsSaving,
  isSubscribed: state.subscribed,
  currentCartQuantity: getLineItemQuantitySaved(state, props),
});

export const mapDispatchToProps = dispatch => ({
  addOfferingWithoutQuantityInput: lineItem => {
    dispatch(
      changeVariantQuantity(
        { sku: lineItem.sku },
        lineItem.offeringId,
        lineItem.quantity
      )
    );
    dispatch(saveCartRequest([lineItem], true));
  },
  updateLineItems: (lineItemsPending, isCommitting) => {
    dispatch(saveCartRequest(lineItemsPending, isCommitting));
  },
  openCartForDesktop: shouldAutoClose => {
    dispatch(openCartForDesktop(shouldAutoClose));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddToCartButton);
